"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("./browser");
const Param_1 = require("./Param");
const params_1 = require("./params");
const initParam = (key, shortKey, defVal, Z, o) => {
    const param = new Param_1.default(key, shortKey, defVal, Z, o);
    params_1.globalParams.set(key, param);
    return key;
};
const initParamRegex = (expr, fn) => {
    params_1.globalParamRegexes.push([new RegExp('^' + expr + '$'), fn]);
};
exports.default = {
    ApiVersion: initParam('apiVersion', 'v'),
    HitType: initParam('hitType', 't'),
    HitPayload: initParam('hitPayload'),
    SiteSpeedSampleRate: initParam('siteSpeedSampleRate', undefined, 1),
    EntityKey: initParam('entityKey', 'cid'),
    CorellationKey: initParam('corellationKey'),
    StoredClientId: initParam('storedClientId'),
    // misc params
    CampaignId: initParam('campaignId', 'ci'),
    CampaignName: initParam('campaignName', 'cn'),
    CampaignSource: initParam('campaignSource', 'cs'),
    CampaignMedium: initParam('campaignMedium', 'cm'),
    CampaignKeyword: initParam('campaignKeyword', 'ck'),
    CampaignContent: initParam('campaignContent', 'cc'),
    CookieName: initParam('cookieName', void 0, '_sea'),
    CookieDomain: initParam('cookieDomain'),
    CookiePath: initParam('cookiePath', undefined, '/'),
    CookieUpdate: initParam('cookieUpdate', void 0, true),
    CookieExpires: initParam('cookieExpires', void 0, 63072E3),
    AllowAdFeatures: initParam('allowAdFeatures', undefined, true),
    JT: initParam('_jt', undefined, 'n'),
    AlwaysSendReferrer: initParam('alwaysSendReferrer', undefined, false),
    // custom params
    Dimensions: initParamRegex('dimension([0-9]+)', (dataArray) => {
        return new Param_1.default(dataArray[0], 'cd' + dataArray[1]);
    }),
    Metrics: initParamRegex('metric([0-9]+)', (dataArray) => {
        return new Param_1.default(dataArray[0], 'cm' + dataArray[1]);
    }),
    // auto params
    ScreenColors: initParam('screenColors', 'sd'),
    ScreenResolution: initParam('screenResolution', 'sr'),
    ViewportSize: initParam('viewportSize', 'vp'),
    JavaEnabled: initParam('javaEnabled', 'je'),
    ScreenEd: initParam('_j1', 'jid'),
    ScreenIa: initParam('_j2', 'gjid'),
    // pageview params
    Location: initParam('location', 'dl', ''),
    Referrer: initParam('referrer', 'dr'),
    Page: initParam('page', 'dp', ''),
    HostName: initParam('hostname', 'dh'),
    Language: initParam('language', 'ul'),
    Encoding: initParam('encoding', 'de'),
    Title: initParam('title', 'dt', () => {
        return browser_1.default.getDocument().title || undefined;
    }),
    // event params
    EventCategory: initParam('eventCategory', 'ec'),
    EventAction: initParam('eventAction', 'ea'),
    EventLabel: initParam('eventLabel', 'el'),
    EventValue: initParam('eventValue', 'ev'),
    // timing params
    TimingCategory: initParam('timingCategory', 'utc'),
    TimingVar: initParam('timingVar', 'utv'),
    TimingLabel: initParam('timingLabel', 'utl'),
    TimingValue: initParam('timingValue', 'utt'),
    TimingEb: initParam('l1', 'plt'),
    TimingFb: initParam('l2', 'pdt'),
    TimingGb: initParam('l3', 'dns'),
    TimingHb: initParam('l4', 'rrt'),
    TimingIb: initParam('l5', 'srt'),
    TimingJb: initParam('l6', 'tcp'),
    TimingKb: initParam('l7', 'dit'),
    TimingLb: initParam('l8', 'clt'),
    TimingVe: initParam('l9', '_gst'),
    TimingWe: initParam('l10', '_gbt'),
    // social params
    SocialNetwork: initParam('socialNetwork', 'sn'),
    SocialAction: initParam('socialAction', 'sa'),
    SocialTarget: initParam('socialTarget', 'st'),
    // screenview params
    AppName: initParam('appName', 'an'),
    AppVersion: initParam('appVersion', 'av', ''),
    AppId: initParam('appId', 'aid', ''),
    AppInstallerId: initParam('appInstallerId', 'aiid', ''),
    ExDescription: initParam('exDescription', 'exd'),
    ExFatal: initParam('exFatal', 'exf'),
    // item params
    // TODO
    // transaction params
    // TODO
    // tasks
    SendHitTask: initParam('sendHitTask'),
    BuildHitTask: initParam('buildHitTask'),
    DisplayFeaturesTask: initParam('displayFeaturesTask'),
    TimingTask: initParam('timingTask'),
    // sea custom payload properties
    Properties: initParam('properties', 'pp'),
};
